import { ActionDiv } from "PFComponents/divs";
import { Icon, IconSize } from "PFComponents/icon";
import { useCallback } from "react";

import { useBookingFormContext } from "../../../../components/booking_form";
import { BookingFormMode } from "../../../../components/booking_form/use_booking_form";
import { CalendarGranularity } from "../../../../types";
import { BAR_HEIGHT } from "../calendar";
import { HoverPeriodData } from "./row";
import css from "./row.module.scss";

const toISODateString = (date: Date) => date.toISOString().split("T")[0];
const getIconSize = (width: number): IconSize => {
  if (width < XXS_WIDTH) {
    return "xxs";
  } else if (width < XS_WIDTH) {
    return "xs";
  } else {
    return "sm";
  }
};

const SM_WIDTH = 40;
const XS_WIDTH = 30;
const XXS_WIDTH = 20;
const MIN_WIDTH = 8;

type HoveredPeriodIndicatorProps = {
  id: string;
  calendarGranularity: CalendarGranularity;
  period: HoverPeriodData["period"];
  offsetTop: number;
  profileId: number;
  activityId?: number;
  center: boolean;
};

export const HoveredPeriodIndicator = ({
  id,
  calendarGranularity,
  period,
  offsetTop,
  profileId,
  activityId,
  center
}: HoveredPeriodIndicatorProps) => {
  const {
    modal: { open: openModal }
  } = useBookingFormContext();

  const handleClick = useCallback(() => {
    const startDateObject = "date" in period ? period.date : period.startDate;
    const endDateObject = "date" in period ? period.date : period.endDate;
    const startDate = toISODateString(startDateObject);
    const endDate = toISODateString(endDateObject);
    openModal(
      {
        profileId,
        activityId,
        bookings: [
          {
            startDate,
            endDate
          }
        ]
      },
      { mode: BookingFormMode.Create }
    );
  }, [calendarGranularity, openModal, profileId, activityId, period]);

  return (
    <div
      id={id}
      className={css.hoverPeriodIndicatorContainer}
      style={{
        left: period.left,
        width: period.width,
        maxWidth: period.width
      }}
    >
      <div
        className={css.actionContainer}
        style={{
          top: offsetTop,
          height: BAR_HEIGHT,
          padding: `${period.width > SM_WIDTH ? "var(--spacingXs)" : 0} ${
            period.width > SM_WIDTH ? "var(--spacingMd)" : 0
          }`,
          position: center ? "static" : "absolute"
        }}
      >
        <ActionDiv ariaLabel="" onClick={handleClick} className={css.hoverPeriodIndicator}>
          {period.width > MIN_WIDTH && <Icon name="add" size={getIconSize(period.width)} />}
        </ActionDiv>
      </div>
    </div>
  );
};
